<template>
  <div class="item">
    <div class="foto">
      <img :src="clinic.logo" @error="handleImageError" alt="Foto da Clínica" />
    </div>
    <div class="nome">
      <h3>{{ clinic.name }}</h3>
      <p>Profesional acreditado</p>
    </div>
    <button class="telefone" @click="openLink(`tel:${clinic.contact}`)">
      <img src="@/assets/images/icone-telefone.svg" alt="Telefone" />
    </button>
    <button class="localizacao" @click="openMap(clinic.address)">
      <img src="@/assets/images/icone-localizacao.svg" alt="Localização" />
    </button>
    <button class="instagram" @click="openLink(clinic.instagram)">
      <img src="@/assets/images/icone-instagram.png" alt="Instagram" />
    </button>
    <button
        class="whatsapp"
        @click="openLink(`https://wa.me/${formatWhatsAppNumber(clinic.whatsapp)}`)"
    >
      <img src="@/assets/images/icone-whatsapp.png" alt="WhatsApp" />
      <p>Whatsapp</p>
    </button>
  </div>
</template>

<script setup>
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/system-oligocheck.appspot.com/o/clinics%2F1757882609228_SOCHECK.jpeg?alt=media&token=6b02c18c-cc05-4d35-a4c3-f3074e6b4c3f';

defineProps({
  clinic: {
    type: Object,
    required: true
  }
})

const handleImageError = (event) => {
  event.target.src = defaultImage;
};

const openLink = (url) => {
  if (url) {
    window.open(url, "_blank");
  }
};

const openMap = (address) => {
  if (address) {
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, "_blank");
  }
};

const formatWhatsAppNumber = (number) => {
  if (!number) return '';
  return number.replace(/\D/g, "");
};
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f3f8fa;
  border-radius: 10px;
  padding: 15px 170px 15px 15px;
  position: relative;
  width: 100%;
  margin: 0 0 20px 0;
  border: 1px solid #e0e0e035;
}
.item .foto {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border: 3px solid #2280b4;
  border-radius: 50%;
  overflow: hidden;
}
.item .foto img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item button.whatsapp {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-branco);
  text-align: center;
  width: 100%;
  max-width: 150px;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #2280b4;
  border-radius: 10px;
  transition: all 0.3s;
}
.item button.whatsapp img {
  width: 100%;
  max-width: 20px;
  margin: 0 10px 0 0;
}
.item button.whatsapp:hover {
  background-color: #103e7f;
}
.item button.instagram {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #2280b4;
  border-radius: 10px;
  margin: 0 0 0 20px;
  transition: all 0.3s;
}
.item button.instagram img {
  width: 100%;
  max-width: 20px;
}
.item button.instagram:hover {
  background-color: #103e7f;
}
.item button.localizacao {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #2280b4;
  border-radius: 10px;
  margin: 0 0 0 20px;
  transition: all 0.3s;
}
.item button.localizacao img {
  width: 100%;
  max-width: 15px;
}
.item button.localizacao:hover {
  background-color: #103e7f;
}
.item button.telefone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #2280b4;
  border-radius: 10px;
  transition: all 0.3s;
}
.item button.telefone img {
  width: 100%;
  max-width: 15px;
}
.item button.telefone:hover {
  background-color: #103e7f;
}
.item .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 15px;
  margin-right: auto;
}
.item .nome h3 {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-preto);
}
.item .nome p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-preto);
  margin: 5px 0 0 0;
}

@media screen and (max-width: 1000px) {
  .item {
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 20px;
  }
  .item .foto {
    margin: 0 0 20px 0;
  }
  .item button.whatsapp {
    padding: 10px 20px;
    margin: 0 0 0 10px;
    height: 50px;
    width: auto;
    max-width: none;
    position: relative;
    bottom: auto;
    right: auto;
  }
  .item button.instagram {
    margin: 0 0 0 10px;
  }
  .item button.localizacao {
    margin: 0 0 0 10px;
  }
  .item .nome {
    padding: 0 0 20px 15px;
    margin-right: 0;
    width: calc(100% - 55px);
  }
}
</style> 